import {LLAVEINTEGRIDAD} from "../Constantes";

export const obtenerHash = async ({idVenta, valor, moneda,fechaExpiracion }) =>{

    var cadenaConcatenada = `${idVenta}${valor}${moneda}${fechaExpiracion}${LLAVEINTEGRIDAD}`

    const encondedText = new TextEncoder().encode(cadenaConcatenada);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encondedText);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
    return hashHex

}